export const getPendingTasks = (state) => {
    return state.pendingTasks;
}

export const getLoadingTasks = (state) => {
    return state.loadingTasks;
}

